import { useAuth0 } from '@auth0/auth0-react';
import { Button, Grid } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../layout/Modal';
import { CompaniesContext } from '../layout/navigation/CompaniesContextProvider';
import Output from '../layout/Output';
import Section from '../layout/Section';
import PropTypes from 'prop-types';
import useChangePassword from './useChangePassword';
import LayoutPage from '../layout/LayoutPage';
import TermsAndConditions from '../termsAndConditions/TermsAndConditions';
import { formatAcceptedDate, termsAndConditionsAcceptedDateClaim } from '../termsAndConditions/acceptedDate';
import WorkerLayoutPage from '../worker/WorkerLayout';

const Layout = ({ isWorker, children, ...props }) => {
  const LayoutComponent = isWorker ? WorkerLayoutPage : LayoutPage;
  return <LayoutComponent {...props}>{children}</LayoutComponent>;
};

Layout.propTypes = {
  isWorker: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

const ProfilePage = ({ isWorker }) => {
  const { t, i18n } = useTranslation('profile');

  const { user } = useAuth0();
  const { currentCompanies } = useContext(CompaniesContext);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const canReadTerms = !isWorker && (currentCompanies ?? []).length === 0;
  const termsActions = canReadTerms ? [{ label: t('termsOfUse'), onClick: () => setIsTermsOpen(true) }] : [];

  const [sendChangePasswordRequest] = useChangePassword();

  return (
    <Layout isWorker={isWorker}>
      <Section title={t('profileInformation')} actions={termsActions}>
        <Grid container spacing={2}>
          <Grid item xs={8} md={3}>
            <Output id="output-name" label={t('name')} defaultValue={user.name} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Output id="output-email" label={t('email')} defaultValue={user.email} />
          </Grid>
          <Grid item xs={6} md={6}>
            <Button variant="outlined" color="primary" onClick={() => sendChangePasswordRequest(user)}>
              {t('changePassword')}
            </Button>
          </Grid>
        </Grid>
      </Section>
      {canReadTerms && (
        <Modal open={isTermsOpen} onClose={() => setIsTermsOpen(false)}>
          <TermsAndConditions acceptedDate={formatAcceptedDate(user[termsAndConditionsAcceptedDateClaim], i18n.language)} />
        </Modal>
      )}
    </Layout>
  );
};

ProfilePage.propTypes = {
  isWorker: PropTypes.bool.isRequired,
};

export default ProfilePage;
